import React from "react";
import { useTranslation } from "react-i18next";
import useScrollAnimation from "@/hooks/useScrollAnimation";
import { useBooking } from "@/context/BookingContext";
import { trackEvent } from "@/utils/analytics";
import "./CTABandSection.scss";

const ArrowIcon = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
    <path d="M3 8h10M9 4l4 4-4 4" />
  </svg>
);

const CTABandSection: React.FC = () => {
  const { t } = useTranslation();
  const { openBooking } = useBooking();
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.2 });

  return (
    <section className="cta-band-section" ref={ref}>
      <div className={`container cta-inner reveal${isVisible ? " in" : ""}`}>
        <h2>
          {(() => {
            const title = t("cta.title");
            const hl = t("cta.titleHighlight");
            const [before, after = ""] = title.split(hl);
            return <>{before}<em>{hl}</em>{after}</>;
          })()}
        </h2>
        <p>{t("cta.subtitle")}</p>
        <button className="btn btn-accent" onClick={() => { trackEvent("cta_click", { location: "cta_band" }); openBooking("cta_band"); }}>
          {t("booking.cta")} <ArrowIcon />
        </button>
      </div>
    </section>
  );
};

export default CTABandSection;
